import { render, staticRenderFns } from "./roomLayoutEdit.vue?vue&type=template&id=6a0c9a8a&scoped=true"
import script from "./roomLayoutEdit.vue?vue&type=script&lang=js"
export * from "./roomLayoutEdit.vue?vue&type=script&lang=js"
import style0 from "./roomLayoutEdit.vue?vue&type=style&index=0&id=6a0c9a8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0c9a8a",
  null
  
)

export default component.exports